import { IconButton, IconButtonProps, useTheme } from '@mui/material';

export const CommonEditIconButton = (props: IconButtonProps) => {
  const theme = useTheme();
  return (
    <IconButton size="small" {...props}>
      <i
        className="fa-light fa-pen-to-square"
        style={{ color: theme.palette.info.main }}
      />
    </IconButton>
  );
};
